import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Teaching`}</h2>
    <p><strong parentName="p">{`Course chair and instructor:`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`STAT 3410 - Probability and Statistics (2013F, 2014F, 2015F, 2016F & 2017F)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`STAT 3411 - Statistical Inference I (2014W & 2019F)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`STAT 4590 - Statistical Analysis of Data I (2016W)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`STAT 4410 - Statistical Inference II (2017F)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`STAT 6505 - Survival Analysis (2014F, 2016F & 2018F)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`STAT 6561 - Categorical Data Analysis (2020W)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`MED 6260 - Applied Data Analysis for Clinical Epidemiology (2014W, 2015W & 2016W)`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Coordinator:`}</strong></p>
    <ul>
      <li parentName="ul">{`STAT 697A & STAT 697B - Graduate Seminar in Statistics (2016F & 2017W, 2018F & 2019W)`}</li>
    </ul>
    <p><strong parentName="p">{`Guest Lecturer:`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`MED 6393 - Human Molecular Genetics (2016F)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`MED 6390 - Population Genetics (2017W)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`MED 6395 - Genetic Epidemiology (2018W)`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      